import ClassPriceView from '@pages/CoursesCatalog/modals/ClassEnrollmentModal/components/ClassPriceView/ClassPriceView'
import { FormInstance } from 'antd'
import { useWatch } from 'antd/es/form/Form'
import { FC } from 'react'

interface ClassPriceViewWrapperProps {
  form: FormInstance<any>
}

const ClassPriceViewWrapper: FC<ClassPriceViewWrapperProps> = ({ form }) => {
  const firstPriceWatch = useWatch('first_price', form) as number | null
  const priceWatch = useWatch('price', form) as number | null
  // const discountValue = useWatch('discount', form) as number | null
  const valueWatch = useWatch('value', form) as number | null

  const price =
    (firstPriceWatch === null || firstPriceWatch === undefined
      ? priceWatch
      : firstPriceWatch) ?? 0

  return (
    <ClassPriceView
      startPrice={
        // discountValue
        //   ? Number(((valueWatch ?? 1) * (price ?? 0)).toFixed(2))
        //   : 
          null
      }
      currentPrice={Number(
        (
          (valueWatch ?? 1) * (price ?? 0) 
          // -
          // (valueWatch ?? 1) * (discountValue ?? 0)
        ).toFixed(2),
      )}
    />
  )
}

export default ClassPriceViewWrapper
